import mimeStartsWith from 'utils/mimeStartsWith';

const isVideo = object => mimeStartsWith(object, 'video/');

export default isVideo;
